<template lang="pug">
.home-banner
  .banner-100(v-if="showBanner")
    carousel(
      items="1",
      :autoplay="true",
      :dots="false",
      :nav="false",
      :margin="15",
      :loop="true"
    )
      .nav-content(v-for="(banner, index) in banners")
        img.nav-img.desktop-img(:src="banner.image")
        img.nav-img.mobile-img(:src="banner.smimg")

</template>
<script>
import carousel from 'v-owl-carousel'
export default {
  name: 'BannerPlugin',
  components: {
    carousel
  },
  data () {
    return {
      siteType: '',
      showBanner: false,
      banners: [],
    };
  },
  async created () {
    // 獲取路由參數中的 siteType
    this.siteType = this.$route.params.siteType;
    console.log('siteType:', this.siteType);
    // 獲取 Banner 資料
    this.getBannerData()
  },
  destroyed () {
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // 獲取 Banner 資料
    async getBannerData () {
      await this.$root.apis.getBannerInfo(1, this.siteType, this.processGetBannerSuccess, this.processStatusError)
    },
    // 成功獲取 Banner
    async processGetBannerSuccess (_response) {
      this.banners = _response.body
      setTimeout(() => {
        this.showBanner = true
        this.processSendHightToOutsite()
      }, 500);
    },
    // 失敗獲取 Banner
    async processStatusError (_error) {

    },
    // 遞送資訊給外部
    processSendHightToOutsite () {
      setTimeout(() => {
        const observer = new ResizeObserver(this.sendHeight);
        observer.observe(document.body);
      }, 500);
    },
    sendHeight () {
      // 子頁面的 JavaScript（iframe 裡的內容）
      const height = document.body.scrollHeight;
      window.parent.postMessage({ type: 'setHeight', height }, '*');
      console.log('--> 告知外部 Banner 高度:', height);
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-img {
  &.desktop-img {
    display: block;

    @media (max-width: 768px) {
      display: none;
    }
  }

  &.mobile-img {
    display: none;

    @media (max-width: 768px) {
      display: block;
    }
  }
}
</style>
